import { Expose } from 'class-transformer';
import { IsOptional, IsString } from 'class-validator';

export class UpdateStoreStatusFeatureNoteDto {
  @IsString()
  @IsOptional()
  @Expose()
  featureNote?: string;
}
